import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ReactMapGL, { Popup, LinearInterpolator } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { WebMercatorViewport } from '@deck.gl/core';
import DeckGL, { IconLayer } from 'deck.gl';
import PINS from '../../assets/images/pins.svg';
import MARKERS from '../../assets/images/markers.svg';
import _ from 'lodash'
import { autorun } from 'mobx';
import moment from 'moment';
import {Button} from "./styles";

@inject('userStore')
@observer
class ShipmentTooltip extends Component {
  render() {
    const { shipment, userStore } = this.props;
    const { blurCustomerInfo, blurCustomerAddress } = userStore;

    const blurInfoStyle = blurCustomerInfo ? { color: 'transparent', textShadow: '0 0 10px rgba(0, 0, 0, 0.6)' } : {};
    const blurAddressStyle = blurCustomerAddress ? { color: 'transparent', textShadow: '0 0 10px rgba(0, 0, 0, 0.6)' } : {};

    return (
      <div style={{ minWidth: '200px', fontSize: '13px' }}>
        <div style={blurInfoStyle}>
          <b>{shipment.customer.name}</b>
        </div>
        <div style={{ color: '#888', ...blurInfoStyle }}>{shipment.customer.phone_number}</div>
        <div style={{ color: '#888', marginBottom: '4px', ...blurInfoStyle }}>{shipment.customer.email}</div>
        <div style={blurAddressStyle}>
          {shipment.dropoff_address.street} {shipment.dropoff_address.street2 ? ', ' + shipment.dropoff_address.street2 : ''}
        </div>
        <div>
          {shipment.dropoff_address.city}, {shipment.dropoff_address.state} {shipment.dropoff_address.zipcode}
        </div>
      </div>
    );
  }
}

@inject('deliveryStore', 'shipmentStore')
class DeliveryMapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zoom: 13,
      viewport: {
        latitude: 37.7577,
        longitude: -122.4376,
        zoom: 11
      },
      layers: [],
      mapStyle: `https://api.maptiler.com/maps/${import.meta.env.REACT_APP_MAP_TILER_STYLE}/style.json?key=${import.meta.env.REACT_APP_MAP_TILER_KEY}`
    };


    this.iconMapping = {};
    const iconW = 112, iconH = 340, iconAnchor = 312;
    this.iconMapping['shadow'] = {
        x: 0, y: iconH, width: 264, height: iconH, anchorY: iconAnchor, anchorX: iconW / 2
    };
    this.iconMapping['succeeded'] = {
        x: 0, y: 0, width: iconW, height: iconH, anchorY: iconAnchor
    };
    this.iconMapping['failed'] = {
        x: iconW, y: 0, width: iconW, height: iconH, anchorY: iconAnchor
    };
    this.iconMapping['inprogress'] = {
        x: iconW * 2, y: 0, width: iconW, height: iconH, anchorY: iconAnchor
    };
    this.iconMapping['pending'] = {
        x: iconW * 3, y: 0, width: iconW, height: iconH, anchorY: iconAnchor
    };
    this.iconMapping['unrouted'] = {
        x: iconW * 4, y: 0, width: iconW, height: iconH, anchorY: iconAnchor
    };

    this.showShipmentTooltip = this.showShipmentTooltip.bind(this)
  }

  componentDidMount() {
    this.markerDisposer = autorun(() => {
      const { deliveryStore } = this.props;
      const { shipments, selectedShipment } = deliveryStore;

      this.setState({layers: this._processDropoffMap(shipments.map(s => s.shipment), selectedShipment)})
    }, {delay: 100});

    this.boundaryDisposer = autorun(() => {
      const { deliveryStore } = this.props;
      const { boundary } = deliveryStore;

      if (!boundary)
        return;

      this.fitBoundary(boundary)
    }, {delay: 100})
  }

  fitBoundary(boundary) {
    if (this.currentBoundary && this.currentBoundary === boundary) {
      return
    }

    if (this.currentBoundary) {
      if (
        Math.abs(boundary[0][0] - this.currentBoundary[0][0]) < 0.0002
        && Math.abs(boundary[0][1] - this.currentBoundary[0][1]) < 0.0002
        && Math.abs(boundary[1][1] - this.currentBoundary[1][1]) < 0.0002
        && Math.abs(boundary[1][0] - this.currentBoundary[1][0]) < 0.0002
      )
      return;
    }
        
    this.currentBoundary = boundary;
    if (!this.state.viewport)
      return;
    // too small box
    let isTooSmall = boundary[1][0] -  boundary[0][0] < 0.0004;
    let c = { latitude: boundary[0][1], longitude: boundary[0][0], zoom: 15};
    const viewport = new WebMercatorViewport(this.state.viewport);    

    let { longitude, latitude, zoom } = isTooSmall ? c : viewport.fitBounds(
        boundary.slice().map(b => b.slice()),
        { padding: 40 }
    );    

    this.setState({
      viewport: {
        ...this.state.viewport,
        longitude,
        latitude,
        zoom,
        transitionDuration: 500
      }
    });
  }

  componentWillUnmount() {
    if (this.markerDisposer) this.markerDisposer();
    if (this.boundaryDisposer) this.boundaryDisposer();
  }

  showShipmentTooltip(shipment) {
    this.setState({hoveredShipment: shipment});
  }

  selectShipment(shipment) {
    const { deliveryStore } = this.props;
    const { regions, stores, start } = deliveryStore;
    const region = regions.length > 0 ? regions.join(',') : 'all'
    const day = moment(start * 1000).format('YYYY-MM-DD');
    const store = stores.length > 0 ? stores.join(',') : '';
    const storeString = !!store ? `?stores=${store}` : '';

    if (!shipment || (deliveryStore.selectedShipment && deliveryStore.selectedShipment.id === shipment.id)) {
      // UNSELECT
      this.props.history.push(`/deliveries/${day}/${region}${storeString}`);
      deliveryStore.setSelectedShipment(null)
    } else {
      deliveryStore.setSelectedShipment(shipment);
      this.props.history.push(`/deliveries/${day}/${region}/${shipment.id}${storeString}`)
    }
  }

  _renderShipmentTooltip() {
    const { hoveredShipment } = this.state;
    return hoveredShipment && (
        <Popup tipSize={5}
            anchor="bottom"
            closeButton={false}
            longitude={ hoveredShipment.location[0] }
            latitude={ hoveredShipment.location[1] }
            offsetTop={-40}
            className={'map-tooltip'}
            onClose={() => this.setState({ hoveredStop: null })} >
            <ShipmentTooltip shipment={ hoveredShipment.shipment } />
        </Popup>
    );
  }

  _renderDropoffTooltip() {
    const { actualDropoffTooltip } = this.state;
    return actualDropoffTooltip && (
      <Popup
        tipSize={5}
        anchor="bottom"
        closeButton={true}
        closeOnClick={false}
        longitude={actualDropoffTooltip.longitude}
        latitude={actualDropoffTooltip.latitude}
        offsetTop={-10}
        className={'map-tooltip'}
        onClose={() => this.setState({ actualDropoffTooltip: null })}
      >
        <div style={{ fontSize: 13 }}>
          <div>Actual Dropoff Coordinate</div>
          <div>
            <strong>{actualDropoffTooltip.latitude.toLocaleString('en-US', { maximumFractionDigits: 5 })}</strong>
            <span>, </span>
            <strong>{actualDropoffTooltip.longitude.toLocaleString('en-US', { maximumFractionDigits: 5 })}</strong>
          </div>
          <div style={{ marginTop: 5 }}>
            <Button
              target="_blank"
              rel="noopener noreferrer"
              href={`https://www.google.com/maps/search/?api=1&query=${actualDropoffTooltip.latitude},${actualDropoffTooltip.longitude}`}
            >
              Open in GG Maps
            </Button>
          </div>
        </div>
      </Popup>
    );
  }

  _markerIcon(shipment) {
    if (_.isNil(shipment.assignment_id)) return 'unrouted';
    const map = {
      DROPOFF_SUCCEEDED: 'succeeded',
      DROPOFF_FAILED: 'failed',
      PICKUP_FAILED: 'failed',
      DROPOFF_READY: 'inprogress',
      PICKUP_SUCCEEDED: 'inprogress',
    };
    return _.defaultTo(map[shipment.status], 'pending')
  }

  _processDropoffMap(shipments, selected) {
    const validShipments = _.sortBy(shipments.slice(), s => -s.dropoff_address.lat)
      .filter(sh => !!sh.dropoff_address.lat && !!sh.dropoff_address.lng);

    const shadows = validShipments.flatMap(s => [
      {
          location: [s.dropoff_address.lng, s.dropoff_address.lat],
          size: 40,
          icon: 'shadow'
      }
    ]);
    const icons = validShipments.flatMap(s => [
      {
          location: [s.dropoff_address.lng, s.dropoff_address.lat],
          shipment: s,
          size: 40,
          icon: this._markerIcon(s)
      }
    ]);
    const dropoffMarkers = shadows.concat(icons);

    const dropoffIconlayer = new IconLayer({
        id: 'dropoff-icon-layer',
        data: dropoffMarkers,
        pickable: true,
        // iconAtlas and iconMapping are required
        // getIcon: return a string
        iconAtlas: PINS,
        iconMapping: this.iconMapping,
        getIcon: d => d.icon,
        sizeScale: 1,
        opacity: selected ? 0.25 : 1,
        visible: true,
        getPosition: d => d.location,
        getSize: d => d.size,
        onHover: (info) => {
          const {object} = info;
          if (object && object.shipment)
            this.showShipmentTooltip(object);
          if (!object)
            this.showShipmentTooltip(null);
        },
        onClick: (info) => {
          const {object} = info;
          if (object && object.shipment)
            this.selectShipment(object.shipment);
          if (!object)
            this.selectShipment(null);
        }
    });

    const selectedIcon = selected ? [
      new IconLayer({
          id: 'selected-dropoff-icon-layer',
          data: [
            {
              location: [selected.dropoff_address.longitude, selected.dropoff_address.latitude],
              shipment: selected,
              size: 40,
              icon: this._markerIcon(selected)
            }
          ],
          pickable: true,
          // iconAtlas and iconMapping are required
          // getIcon: return a string
          iconAtlas: PINS,
          iconMapping: this.iconMapping,
          getIcon: d => d.icon,
          sizeScale: 1,
          opacity: 1,
          visible: true,
          getPosition: d => d.location,
          getSize: d => d.size,
          onHover: (info) => {
            const {object} = info;
            if (object && object.shipment)
              this.showShipmentTooltip(object);
            if (!object)
              this.showShipmentTooltip(null)
          },
          onClick: () => {
            this.selectShipment(null)
          }
      })
    ] : [];

    return [dropoffIconlayer].concat(selectedIcon)
  }

  processActualDropoff = () => {
    const {deliveryStore, shipmentStore} = this.props;
    const {selectedShipment, showActualDropoffMarker} = deliveryStore;
    const {activeShipment} = shipmentStore;

    if (!showActualDropoffMarker) return [];

    if (!!selectedShipment && selectedShipment.status === 'DROPOFF_SUCCEEDED' && !_.isEmpty(activeShipment) && !!activeShipment.history) {
      const {outbound_events} = activeShipment.history;
      if (!!outbound_events && !_.isEmpty(outbound_events)) {
        const dropoffSucceededStop = outbound_events.filter(ev => ev.signal === "DROPOFF_SUCCEEDED").shift();
        if (!!dropoffSucceededStop && dropoffSucceededStop.geolocation) {
          const {latitude, longitude} = dropoffSucceededStop.geolocation;
          const data = [{
            location: [longitude, latitude],
            dropoff: {latitude, longitude},
            size: 30,
            icon: 'dropoff'
          }];


          return new IconLayer({
            id: 'dropoff-actual-icon-layer',
            data: data,
            pickable: true,
            // iconAtlas and iconMapping are required
            // getIcon: return a string
            iconAtlas: MARKERS,
            iconMapping: {"dropoff": {x: 690, y: 220, width: 60, height: 60}},
            getIcon: d => d.icon,
            sizeScale: 1,
            opacity: 1,
            visible: true,
            getPosition: d => d.location,
            getSize: d => d.size,
            onHover: (info) => {
              const {object} = info;
            },
            onClick: (info) => {
              const {object} = info;
              this.setState({actualDropoffTooltip: (object && object.dropoff) || null});
              // if (object && object.dropoff) {
              //   window.open('https://google.com', '_blank');
              // }
            }
          });
        }
      }
    }
    return null;
  };

  render() {
    const {layers} = this.state;
    const mapLayers = layers.concat([this.processActualDropoff()]);

    const { latitude, longitude, zoom, bearing, pitch } = this.state.viewport;
    const deckViewState = {
      latitude,
      longitude,
      zoom,
      bearing,
      pitch
    };

    return <ReactMapGL
        {...this.state.viewport}
        mapStyle={this.state.mapStyle}
        transitionInterpolator={new LinearInterpolator()}
        onViewportChange={(viewport) => this.setState({ viewport })}
        width={'100%'}
        height={'100%'}
        ref={map => this.mapRef = map}
    >
      <DeckGL
        onClick={(info) => {
          if (!info || !info.object) {
            this.setState({ hoveredShipment: null, actualDropoffTooltip: null })
          }
        }}
        viewState={deckViewState}
        layers={mapLayers}
        controller={true}
      />
      { this._renderShipmentTooltip() }
      { this._renderDropoffTooltip() }
    </ReactMapGL>
  }
}

export default DeliveryMapContainer
